import { render, staticRenderFns } from "./RequiredFieldsMessage.vue?vue&type=template&id=21ab4151"
import script from "./RequiredFieldsMessage.vue?vue&type=script&lang=js"
export * from "./RequiredFieldsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports